/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ houseName: NonNullable<unknown> }} Intervention_Plan_Pdf_SiteInputs */



/**
* | output |
* | --- |
* | "Site: {houseName}" |
*
* @param {Intervention_Plan_Pdf_SiteInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_site = /** @type {((inputs: Intervention_Plan_Pdf_SiteInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_SiteInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Site: ${i?.houseName}`)
	return /** @type {LocalizedString} */ (`Site : ${i?.houseName}`)
});